import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import useReveal from "../../hooks/useReveal";

import "./timeline.scss";

const stops = [
  {
    period: "Dec 2024 to present",
    org: "Volleyball Legends",
    role: "Co-Founder & Lead Engineer",
    blurb: "Building the backend of the biggest volleyball game in the world: matchmaking, state sync, data systems, and live ops for 124 million monthly players.",
    stat: "4,000,000,000",
    statLabel: "total plays",
    live: true,
  },
  {
    period: "Summer 2025",
    org: "Amgen",
    role: "Software Engineer Intern",
    blurb: "Built an AI research assistant for epidemiologists, plus large-scale data pipelines on AWS and Databricks.",
    stat: "40%",
    statLabel: "faster literature review",
  },
  {
    period: "2023 to 2026",
    org: "University of Minnesota",
    role: "Honors Student",
    blurb: "B.S. in Computer Science through the University Honors Program.",
    stat: "2026",
    statLabel: "graduation year",
  },
  {
    period: "2023",
    org: "HyperPenguin Games",
    role: "Junior Programmer",
    blurb: "Full-stack game development in a large microservice codebase: monetization, data storage, and player trading systems.",
    stat: "15%",
    statLabel: "less CPU load",
  },
  {
    period: "2021 to 2023",
    org: "2BRO Studios",
    role: "Founder & Lead Programmer",
    blurb: "Founded and led a 20-person indie studio to 5 million plays in a single quarter.",
    stat: "1,700,000",
    statLabel: "monthly players at peak",
  },
];

function Stop({ item, index }) {
  const [ref, , cls] = useReveal({ threshold: 0.4 });
  return (
    <li className={`stop${item.live ? " is-live" : ""} ${cls}`} ref={ref} style={{ "--i": index }}>
      <span className="bulb" aria-hidden="true"></span>
      <div className="stop-body">
        <h3>{item.org}</h3>
        <p className="stop-meta">
          {item.role} <span className="stop-sep" aria-hidden="true">·</span> {item.period}
        </p>
        <p className="stop-blurb">{item.blurb}</p>
      </div>
      <p className="stop-stat">
        <span className="stop-stat-value">{item.stat}</span>
        <span className="stop-stat-label">{item.statLabel}</span>
      </p>
    </li>
  );
}

export default function Timeline() {
  return (
    <section className="journey" id="journey">
      <h2 className="section-heading">Where I've played.</h2>
      <ol className="string">
        {stops.map((item, index) => (
          <Stop key={item.org} item={item} index={index} />
        ))}
      </ol>
      <Link className="text-link journey-link" to="/experience">
        See the work <span className="text-link-icon"><ArrowUpRight size={14} weight="bold" /></span>
      </Link>
    </section>
  );
}
